import { Button } from '@/components/ui/button'
import { Select } from 'antd'
import { PaymentAgentDto } from 'api/Wallet/Types/PaymentAgentDto'
import { FilterDescriptor } from 'store/grid'
import { isEmpty, isNotEmpty } from 'utils/is-empty'

export type SelectPaymentAgentModalOpenEvent = { filterId?: string; value: boolean }

export const SelectPaymentAgentFilter = ({
  filter,
  onFilterChange,
  onPaymentAgentModalOpen,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  onPaymentAgentModalOpen?: (event: SelectPaymentAgentModalOpenEvent) => void
}) => {
  const paymentAgentsSelected = filter?.value ?? []
  const selectValues = filter?.value?.map((x: PaymentAgentDto) => x?.id) ?? []

  if (isEmpty(selectValues) && onPaymentAgentModalOpen) {
    return (
      <Button onClick={() => onPaymentAgentModalOpen({ filterId: filter.id, value: true })}>
        Choose Payment Agents
      </Button>
    )
  }

  return (
    <Select
      placeholder='Payment Agents'
      mode='multiple'
      value={selectValues}
      open={false}
      onFocus={() => {
        if (onPaymentAgentModalOpen) {
          onPaymentAgentModalOpen({ filterId: filter.id, value: true })
        }
      }}
      onChange={(values: string[]) => {
        const paymentsAgentState = isNotEmpty(values)
          ? paymentAgentsSelected.filter((x: PaymentAgentDto) => values.includes(x.id))
          : []

        onFilterChange.call(undefined, {
          nextFilter: { ...filter, filterId: filter.id, value: paymentsAgentState },
        })
      }}
      style={{ width: '250px' }}
    >
      {paymentAgentsSelected.map((paymentAgent: PaymentAgentDto) => (
        <Select.Option value={paymentAgent.id} key={paymentAgent.id}>
          {paymentAgent.name}
        </Select.Option>
      ))}
    </Select>
  )
}
